// HeaderBanner.jsx
import React, { useEffect, useState } from "react";
import "./Delete.css";

const textMessages = [
  "24x7 RO SERVICE CARE",
  "Call Us Anytime",
  "RO Routine and AMC Service",
  "Fast & Reliable Support",
];

const Deletebanner = () => {
  const [index, setIndex] = useState(0);
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % textMessages.length);
        setAnimate(true);
      }, 500); // time for disappear animation
    }, 2000); // total cycle

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="banner">
      <div className={`animated-text ${animate ? "enter" : "exit"}`} style={{ color: 'purple'}}>
        {textMessages[index]}
      </div>

      
    </div>
  );
};

export default Deletebanner;
